import React from "react";

export default function Loader() {
  return (
    <svg
      style={{
        marginLeft: "-10",
        background: "none",
        display: "block",
        shapeRendering: "auto",
        float: "left",
      }}
      width="28px"
      height="28px"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
    >
      <g transform="translate(80,50)">
        <g transform="rotate(0)">
          <circle cx="0" cy="0" r="6" fill="#7b68ee" fillOpacity="1">
            <animateTransform
              attributeName="transform"
              type="scale"
              begin="-1.0416666666666665s"
              values="1.5 1.5;1 1"
              keyTimes="0;1"
              dur="1.1904761904761905s"
              repeatCount="indefinite"
            ></animateTransform>
            <animate
              attributeName="fillOpacity"
              keyTimes="0;1"
              dur="1.1904761904761905s"
              repeatCount="indefinite"
              values="1;0"
              begin="-1.0416666666666665s"
            ></animate>
          </circle>
        </g>
      </g>
      <g transform="translate(71.21320343559643,71.21320343559643)">
        <g transform="rotate(45)">
          <circle cx="0" cy="0" r="6" fill="#7b68ee" fillOpacity="0.875">
            <animateTransform
              attributeName="transform"
              type="scale"
              begin="-0.8928571428571428s"
              values="1.5 1.5;1 1"
              keyTimes="0;1"
              dur="1.1904761904761905s"
              repeatCount="indefinite"
            ></animateTransform>
            <animate
              attributeName="fillOpacity"
              keyTimes="0;1"
              dur="1.1904761904761905s"
              repeatCount="indefinite"
              values="1;0"
              begin="-0.8928571428571428s"
            ></animate>
          </circle>
        </g>
      </g>
      <g transform="translate(50,80)">
        <g transform="rotate(90)">
          <circle cx="0" cy="0" r="6" fill="#7b68ee" fillOpacity="0.75">
            <animateTransform
              attributeName="transform"
              type="scale"
              begin="-0.744047619047619s"
              values="1.5 1.5;1 1"
              keyTimes="0;1"
              dur="1.1904761904761905s"
              repeatCount="indefinite"
            ></animateTransform>
            <animate
              attributeName="fillOpacity"
              keyTimes="0;1"
              dur="1.1904761904761905s"
              repeatCount="indefinite"
              values="1;0"
              begin="-0.744047619047619s"
            ></animate>
          </circle>
        </g>
      </g>
      <g transform="translate(28.786796564403577,71.21320343559643)">
        <g transform="rotate(135)">
          <circle cx="0" cy="0" r="6" fill="#7b68ee" fillOpacity="0.625">
            <animateTransform
              attributeName="transform"
              type="scale"
              begin="-0.5952380952380952s"
              values="1.5 1.5;1 1"
              keyTimes="0;1"
              dur="1.1904761904761905s"
              repeatCount="indefinite"
            ></animateTransform>
            <animate
              attributeName="fillOpacity"
              keyTimes="0;1"
              dur="1.1904761904761905s"
              repeatCount="indefinite"
              values="1;0"
              begin="-0.5952380952380952s"
            ></animate>
          </circle>
        </g>
      </g>
      <g transform="translate(20,50.00000000000001)">
        <g transform="rotate(180)">
          <circle cx="0" cy="0" r="6" fill="#7b68ee" fillOpacity="0.5">
            <animateTransform
              attributeName="transform"
              type="scale"
              begin="-0.4464285714285714s"
              values="1.5 1.5;1 1"
              keyTimes="0;1"
              dur="1.1904761904761905s"
              repeatCount="indefinite"
            ></animateTransform>
            <animate
              attributeName="fillOpacity"
              keyTimes="0;1"
              dur="1.1904761904761905s"
              repeatCount="indefinite"
              values="1;0"
              begin="-0.4464285714285714s"
            ></animate>
          </circle>
        </g>
      </g>
      <g transform="translate(28.78679656440357,28.786796564403577)">
        <g transform="rotate(225)">
          <circle cx="0" cy="0" r="6" fill="#7b68ee" fillOpacity="0.375">
            <animateTransform
              attributeName="transform"
              type="scale"
              begin="-0.2976190476190476s"
              values="1.5 1.5;1 1"
              keyTimes="0;1"
              dur="1.1904761904761905s"
              repeatCount="indefinite"
            ></animateTransform>
            <animate
              attributeName="fillOpacity"
              keyTimes="0;1"
              dur="1.1904761904761905s"
              repeatCount="indefinite"
              values="1;0"
              begin="-0.2976190476190476s"
            ></animate>
          </circle>
        </g>
      </g>
      <g transform="translate(49.99999999999999,20)">
        <g transform="rotate(270)">
          <circle cx="0" cy="0" r="6" fill="#7b68ee" fillOpacity="0.25">
            <animateTransform
              attributeName="transform"
              type="scale"
              begin="-0.1488095238095238s"
              values="1.5 1.5;1 1"
              keyTimes="0;1"
              dur="1.1904761904761905s"
              repeatCount="indefinite"
            ></animateTransform>
            <animate
              attributeName="fillOpacity"
              keyTimes="0;1"
              dur="1.1904761904761905s"
              repeatCount="indefinite"
              values="1;0"
              begin="-0.1488095238095238s"
            ></animate>
          </circle>
        </g>
      </g>
      <g transform="translate(71.21320343559643,28.78679656440357)">
        <g transform="rotate(315)">
          <circle cx="0" cy="0" r="6" fill="#7b68ee" fillOpacity="0.125">
            <animateTransform
              attributeName="transform"
              type="scale"
              begin="0s"
              values="1.5 1.5;1 1"
              keyTimes="0;1"
              dur="1.1904761904761905s"
              repeatCount="indefinite"
            ></animateTransform>
            <animate
              attributeName="fillOpacity"
              keyTimes="0;1"
              dur="1.1904761904761905s"
              repeatCount="indefinite"
              values="1;0"
              begin="0s"
            ></animate>
          </circle>
        </g>
      </g>
    </svg>
  );
}
